import React from 'react';

import { getYear } from 'date-fns';

// import { Container, LogoContainer, DetailsContainer, TitleContainer, ProviderContainer } from './style';
import styled from 'styled-components';
import { PAGE_SIDE_PADDING, ScreenSize, MAX_STORE_VIEW_WIDTH } from '../../styling/constants';
import { connect } from 'react-redux';
import { AppState } from 'store/RootReducer';
import { WhiteLabelAcquirerConfigResponse } from 'entities/StoreDetails';
import { FormattedMessage } from 'react-intl';

const Container = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  padding: 0px ${PAGE_SIDE_PADDING}px;
  box-sizing: border-box;
  flex-shrink: 0;
  border-top: 1px solid #eef2f7;

  @media (min-width: ${ScreenSize.XS}px) {
    margin: auto;
    max-width: ${MAX_STORE_VIEW_WIDTH}px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const CopyrightNoticeContainer = styled.div`
  margin-bottom: 10px;
`;

const TermsPolicyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  
  a {
    text-decoration: none;
  }
`;

const LinkSeparator = styled.div`
  width: 5px;
  height: 5px;
  margin: 0px 10px;
  background-color: #969696;
  border-radius: 100%;
`;

const FooterText = styled.p`
  color: #969696;
  font-size: 1.2rem;
`;

interface Props {
  name: string;
  whiteLabelAcquirer?: WhiteLabelAcquirerConfigResponse
}

function StoreFooter(props: Props) {
  const { name, whiteLabelAcquirer } = props;
  const currentYear = getYear(new Date());

  return (
    <Container>
      <CopyrightNoticeContainer>
        <FooterText>Copyright (c) {currentYear} {whiteLabelAcquirer ? whiteLabelAcquirer.shortName : 'Interswitch Group'}. <FormattedMessage id="copyrightDesc" defaultMessage="All rights reserved." /></FooterText>
      </CopyrightNoticeContainer>

      <TermsPolicyContainer>
        <a href={'#'}>
          <FooterText>
            <FormattedMessage id="termsOfUse" defaultMessage="Terms of Use" />
          </FooterText>
        </a>

        <LinkSeparator />

        <a href={'#'}>
          <FooterText>
            <FormattedMessage id="privacyPolicy" defaultMessage="Privacy Policy" />
          </FooterText>
        </a>
      </TermsPolicyContainer>
    </Container>
  );
}

const mapStateToProps = (state: AppState) => ({
  whiteLabelAcquirer: state.store.storeDetails?.whiteLabelAcquirer
})

export default connect(mapStateToProps)(StoreFooter);